import { $externalProfile, $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { FormattedStat } from '@/shared/constants/types'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'

function useFormatExternalUnifiedStats() {
  const userLang = useUnit($userLanguage)

  const units = lang[userLang].pages.units
  const texts = lang[userLang].pages.profile.unifiedStats
  // const steamUserData = useUnit($steamUserData)
  // const farcanaStats = useUnit($farcanaStatistics)
  const externalStats = useUnit($externalProfile)?.stats
  // const calculateDailyPlaytime = (): number => {
  //   if (!steamUserData?.userData.registredAt || !steamUserData.userData.totalHoursPlayed) return 0
  //   const accountAgeInDays = differenceInCalendarDays(Date.now(), new Date(steamUserData.userData.registredAt))
  //   const FAR_avgPlaytime = farcanaStats?.totalHoursPlayed ?? 0
  //   const STEAM_avgPlaytime = steamUserData.userData.totalHoursPlayed / accountAgeInDays
  //   return Number(STEAM_avgPlaytime.toFixed(2)) + FAR_avgPlaytime
  // }

  const [stats, setStats] = useState<FormattedStat[]>([])

  useEffect(() => {
    // const STEAM_totalHoursPlayed = steamUserData?.userData.totalHoursPlayed ?? 0
    // const FAR_totalHoursPlayed = farcanaStats?.totalHoursPlayed ?? 0
    // const TOTAL_playtime = STEAM_totalHoursPlayed + FAR_totalHoursPlayed
    // const TOTAL_gamesOwned = steamUserData?.userData.gamesOwned ?? 0
    // const STEAM_itemsOwned = steamUserData?.userData.itemsOwned ?? 0
    // const STEAM_itemsPrice = steamUserData?.userData.inventoryPrice ?? 0
    // const FAR_itemsPrice = farcanaStats?.totalAssetsValue ?? 0
    // const TOTAL_itemsPrice = Number((STEAM_itemsPrice + FAR_itemsPrice).toFixed(2))
    // const STEAM_accValue = steamUserData?.userData.totalValue ?? 0
    // const FAR_accValue = farcanaStats?.totalAssetsValue ?? 0
    // const TOTAL_accValue = STEAM_accValue + FAR_accValue

    // const totalAssetsPurchased = externalStats?.total_assets_purchased

    setStats([
      { name: texts.totalAccVal, value: `${externalStats?.total_accounts_value} $` },
      { name: texts.totalAssPur, value: `${externalStats?.total_assets_purchased} $` },
      { name: texts.totalHrPlayed, value: `${externalStats?.total_hours_played} ${units.hours}` },
      { name: texts.dailyPlaytime, value: `${externalStats?.daily_playtime} ${units.hours}` },
      { name: texts.gamesOwned, value: externalStats?.games_owned ?? 0 },
      { name: texts.itemsOwned, value: externalStats?.items_owned ?? 0 },
    ])
  }, [
    userLang,
    externalStats,
    texts.totalAccVal,
    texts.totalAssPur,
    texts.totalHrPlayed,
    texts.dailyPlaytime,
    texts.gamesOwned,
    texts.itemsOwned,
    units.hours,
  ])

  return stats
}

export default useFormatExternalUnifiedStats
